import React, { FunctionComponent } from 'react';

import { LayoutModel, ProjectLayoutModel } from '@paragon/contract-library';
import { DataRow } from '@paragon/layout-models';

import { formatGridDate } from '../../dueDates';

export const DateWithoutTimeFormatter: FunctionComponent<{ row?: DataRow<LayoutModel> }> = ({ row }) => {
  if (row?.item.type !== 'project') {
    return null;
  }

  const project = row.item as ProjectLayoutModel;
  const date = Date.parse(project.createdAt);
  if (isNaN(date)) {
    return null;
  }

  return <>{formatGridDate(date)}</>;
};
